import { motion } from "framer-motion";
import { Users, PiggyBank, KeyRound, Store } from "lucide-react";

const STATS = [
  {
    icon: Users,
    value: "1 in 3",
    text: "Canadians were targeted by a fraud attempt in the past year. It is not rare — it is routine.",
    bg: "bg-card",
    span: "lg:col-span-2",
  },
  {
    icon: PiggyBank,
    value: "$638M",
    text: "Reported lost to fraud in Canada in a single year — and most losses never get reported.",
    bg: "bg-secondary",
    span: "",
  },
  {
    icon: KeyRound,
    value: "81%",
    text: "Of breaches start with a weak or reused password. No elite hacker required.",
    bg: "bg-secondary",
    span: "",
  },
  {
    icon: Store,
    value: "$5,000+",
    text: "Average hit a small business takes from one convincing phishing email. Prevention costs far less.",
    bg: "bg-card",
    span: "lg:col-span-2",
  },
];

export default function Stats() {
  return (
    <section className="py-24 lg:py-32" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl mb-16"
        >
          <p className="font-hand text-2xl text-primary mb-3">why this matters</p>
          <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight" data-testid="stats-heading">
            Scams don't target "tech people." They target{" "}
            <span className="text-primary">your mom, your shop, your paycheque.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="stats-grid">
          {STATS.map((s, i) => (
            <motion.div
              key={s.value}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`${s.bg} ${s.span} border border-border rounded-3xl p-8 lg:p-10 hover:-translate-y-1 hover:shadow-md transition-[transform,box-shadow] duration-300`}
              data-testid={`stat-card-${i}`}
            >
              <s.icon className="w-7 h-7 text-primary mb-6" strokeWidth={1.8} />
              <p className="font-display font-semibold text-4xl lg:text-5xl tracking-tight mb-3">{s.value}</p>
              <p className="text-muted-foreground text-sm md:text-base leading-relaxed">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
